import ScalarSidebarSpacer_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarSpacer.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSidebar/ScalarSidebarSpacer.vue
var ScalarSidebarSpacer_default = ScalarSidebarSpacer_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarSpacer_default as default };

//# sourceMappingURL=ScalarSidebarSpacer.vue.js.map